import type { RouteDefinition } from "../catalog/route-definition.ts";
import { matchPattern, type MatchedParams } from "../match-pattern.ts";
import {
  reservedCoworldSegments,
  reservedRootSegments,
} from "../route-namespaces.ts";
import type { MatchCandidate } from "./matched-route.ts";
import { definitions } from "./route-definitions.ts";

const reservedRoots = new Set(
  reservedRootSegments.filter((segment) => segment !== "sugarscape"),
);

function matchGamePattern({
  definition,
  parts,
}: {
  readonly definition: RouteDefinition;
  readonly parts: readonly string[];
}): MatchedParams | null {
  if (definition.scope === "static") return null;

  const pattern = definition.path.split("/").filter(Boolean);

  if (definition.scope === "resource") pattern.unshift(":gameSlug");

  const params = matchPattern({ pattern, parts });

  if (!params) return null;

  const league = params.league;

  if (
    typeof league === "string" &&
    (reservedCoworldSegments.has(league) || league.endsWith(".md"))
  )
    return null;

  return params;
}

export function matchGameRoute(
  parts: readonly string[],
): MatchCandidate | null {
  const unlisted = parts[0] === "unlisted";
  const catalogScope = unlisted ? "unlisted" : "listed";
  const bucket = unlisted ? "unlisted" : "app";
  const entry = unlisted ? "direct" : null;
  const gameParts = unlisted ? parts.slice(1) : parts;
  const [gameSlug, ...tail] = gameParts;

  if (!gameSlug || reservedRoots.has(gameSlug)) return null;

  for (const [name, definition] of definitions) {
    const params = matchGamePattern({ definition, parts: gameParts });

    if (!params) continue;

    const section = tail[params.league ? 1 : 0] ?? "home";
    return {
      name,
      ...params,
      area: "game",
      section,
      catalogScope,
      bucket,
      entry: entry ?? definition.entry,
      disposition: definition.disposition,
    };
  }

  return null;
}
